import React, { useContext, useEffect, useState } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Box,
  TextField,
  Typography,
  Button,
  IconButton,
  Checkbox,
  FormHelperText,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { useMutation, useQuery } from "@apollo/client";
//Icons
import { BiMinusCircle } from "react-icons/bi";
//Srcs
import "../../Style/dialogstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import { SelectAccount } from "../Include/DynamicSelect";
import {
  UPDATE_CHART_OF_ACCOUNT,
  GET_ACCOUNT_TYPE,
} from "../../Schema/ChartOfAccount";
import { SelectAccountName } from "../Include/DynamicSelect";

export default function UpdateSubTwo({
  open,
  handleClose,
  editDataSubTwo,
  editDataSubOne,
  editDataMain,
  setRefetch,
}) {
  // Change Language
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);
  const [loading, setLoading] = useState(false);
  const [parentsAccountVal, setParentsAccountVal] = useState({
    id: "",
    title: "",
  });
  // ========================== checked box =================================
  const [checked, setChecked] = useState(true);
  const hanldleChange = (event) => {
    setChecked(event.target.checked);
  };

  // ========================== get account type =================================
  const [accountTypeData, setAccountTypeData] = useState([]);
  const { refetch: refetchAccountType } = useQuery(GET_ACCOUNT_TYPE, {
    onCompleted: ({ getAccountType }) => {
      // console.log("getAccountType::", getAccountType);
      setAccountTypeData(getAccountType);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const [updateChartOfAccount] = useMutation(UPDATE_CHART_OF_ACCOUNT, {
    onCompleted: ({ updateChartOfAccount }) => {
      setLoading(false);
      if (updateChartOfAccount?.status === true) {
        setAlert(true, "success", updateChartOfAccount?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", updateChartOfAccount?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  //fromik
  const AddChartOfAccount = Yup.object().shape({
    account_type: Yup.string().required("require!"),
    account_name: Yup.string().required("require!"),
    code_account: Yup.string(),
    parents_account: checked ? Yup.string().required("require!") : Yup.string(),
    account_description: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      account_type: "",
      account_name: "",
      account_description: "",
      code_account: "",
      parents_account: "",
    },

    validationSchema: AddChartOfAccount,
    onSubmit: async (values) => {
      setLoading(true);
      updateChartOfAccount({
        variables: {
          chartAccountId: editDataSubTwo._id,
          input: {
            ...values,
          },
        },
      });
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    values,
    resetForm,
  } = formik;

  // console.log("editDataSubTwo::", editDataSubTwo);

  useEffect(() => {
    if (editDataSubTwo) {
      setFieldValue("account_type", editDataSubTwo.account_type);
      setFieldValue("account_name", editDataSubTwo.account_name);
      setFieldValue("account_description", editDataSubTwo.account_description);
      setFieldValue("code_account", editDataSubTwo.code_account);
    }
  }, [editDataSubTwo]);

  // console.log("editDataMain::", editDataMain);

  useEffect(() => {
    if (editDataSubOne) {
      setFieldValue("parents_account", editDataSubOne?._id);
      setParentsAccountVal({
        id: editDataSubOne?._id,
        title: editDataSubOne?.account_name,
      });
    }
  }, [editDataSubOne]);

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="sm">
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">
              Update chart of account
            </Typography>
          </Stack>
          <Box sx={{ flexGrow: 1 }} />
          <IconButton onClick={handleClose}>
            <BiMinusCircle className="close-icon" />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={12} md={12}>
                <Typography className="field-title">Account type</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  size="small"
                  disabled
                  placeholder="account type"
                  {...getFieldProps("account_type")}
                  error={Boolean(touched.account_type && errors.account_type)}
                  helperText={touched.account_type && errors.account_type}
                />
                {/* <FormControl fullWidth>
                  <Select
                    disabled
                    size="small"
                    onChange={(e) =>
                      setFieldValue("account_type", e.target.value)
                    }
                    {...getFieldProps("account_type")}
                    error={Boolean(touched.account_type && errors.account_type)}
                    helperText={touched.account_type && errors.account_type}
                  >
                    {accountTypeData?.map((e) => (
                      <MenuItem key={e} value={e}>
                        {e}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl> */}
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography className="field-title">Code</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  size="small"
                  placeholder="code"
                  {...getFieldProps("code_account")}
                />
              </Grid>

              <Grid item xs={12} md={8}>
                <Typography className="field-title">Account name</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  size="small"
                  placeholder="account name"
                  {...getFieldProps("account_name")}
                  error={Boolean(touched.account_name && errors.account_name)}
                  helperText={touched.account_name && errors.account_name}
                />
              </Grid>

              <Grid item xs={0.5} md={2} sx={{ marginTop: "15px" }}>
                <Checkbox
                  disabled
                  checked={checked}
                  onChange={hanldleChange}
                  iinputProps={{ "aria-label": "controlled" }}
                />
              </Grid>

              <Grid item xs={11.5} md={10}>
                <Typography className="field-title">
                  Select sub account
                </Typography>
                <SelectAccountName
                  selectedVal={parentsAccountVal}
                  setSelectVal={setParentsAccountVal}
                  accountType={values?.account_type}
                  disabled={true}
                />
              </Grid>   

              <Grid item xs={12} md={12}>
                <Typography className="field-title">Description</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  size="small"
                  multiline
                  rows={2}
                  placeholder="description"
                  {...getFieldProps("account_description")}
                  error={Boolean(
                    touched.account_description && errors.account_description
                  )}
                  helperText={
                    touched.account_description && errors.account_description
                  }
                />
              </Grid>
              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    {t("loading")}
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={handleSubmit}
                  >
                    {t("update")}
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
